import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { rupiah } from "../lib/format";

const STATUS_LABEL = {
  PLACED: "Pesanan Dibuat", PURCHASED: "Dibeli dari Supplier", GUANGZHOU_HUB: "Gudang Guangzhou",
  CUSTOMS: "Bea Cukai", INDO_WAREHOUSE: "Gudang Indonesia", DISPATCHED_KEDAI: "Dikirim ke Kedai",
  READY_PICKUP: "Siap Diambil", COMPLETED: "Selesai", CANCELLED: "Dibatalkan",
};

export default function Orders() {
  const [orders, setOrders] = useState(null);
  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data.orders)); }, []);

  if (!orders) return <div className="py-24 flex justify-center text-emerald-600"><Loader2 className="animate-spin" size={32} /></div>;

  if (orders.length === 0)
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center" data-testid="orders-empty">
        <Package size={48} className="mx-auto text-stone-300" />
        <h2 className="font-display text-xl font-bold text-stone-800 mt-4">Belum ada pesanan</h2>
        <Link to="/katalog" className="inline-block mt-5 bg-emerald-600 text-white font-semibold px-6 py-2.5 rounded-full">Mulai Belanja</Link>
      </div>
    );

  return (
    <div className="max-w-4xl mx-auto px-6 py-8">
      <h1 className="font-display text-2xl font-bold text-stone-900 mb-6">Pesanan Saya</h1>
      <div className="space-y-4">
        {orders.map((o) => (
          <Link key={o.id} to={`/pesanan/${o.id}`} data-testid={`order-row-${o.id}`} className="block bg-white rounded-2xl border border-stone-200 p-5 hover:shadow-md transition">
            <div className="flex items-center justify-between mb-3">
              <div>
                <p className="font-mono text-xs text-stone-400">{o.awb}</p>
                <p className="text-sm text-stone-500">{new Date(o.created_at).toLocaleString("id-ID", { day: "numeric", month: "short", year: "numeric" })}</p>
              </div>
              <span className={`text-xs font-bold px-3 py-1 rounded-full ${o.status === "CANCELLED" ? "bg-red-100 text-red-700" : "bg-emerald-50 text-emerald-700"}`}>{STATUS_LABEL[o.status] || o.status}</span>
            </div>
            <div className="flex items-center gap-2">
              {o.items.slice(0, 4).map((it, i) => <img key={i} src={it.image} alt="" className="w-12 h-12 rounded-lg object-cover border border-stone-100" />)}
              {o.items.length > 4 && <span className="text-xs text-stone-400">+{o.items.length - 4}</span>}
              <div className="ml-auto text-right">
                <p className="text-xs text-stone-400">Total</p>
                <p className="font-display font-bold text-emerald-700">{rupiah(o.total_idr)}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
